/* eslint-disable react/prop-types */
import {
  faFileCsv,
  faMagnifyingGlass,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input, Tooltip } from "antd";
import { KeenIcon } from "@/components";
import { FormattedMessage, useIntl } from "react-intl";

const TableToolbar = (props) => {
  const {
    onSearchChange,
    onClickSearch,
    onOpenCreateModal,
    onClickImport,
    onFileChange,
    fileRef,
    tooltipLink,
    searchOptions,
  } = props;
  const intl = useIntl();
  return (
    <div className="flex gap-2 flex-wrap">
      <div className="flex gap-2 flex-1 flex-wrap">
        <div className="flex flex-col gap-3 2xl:flex-row">
          {searchOptions?.map((item) => (
            <div key={item} className="relative">
              <label className="absolute -top-2 left-3 bg-white px-2 text-xs text-gray-600 z-10">
                <FormattedMessage
                  id={`AGENTS.REFERENCE_DATA.${item.toUpperCase()}`}
                />
              </label>
              <Input
                placeholder={`${intl.formatMessage({
                  id: "AGENTS.TABLE_TOOLBAR.SEARCH",
                })}`}
                prefix={
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="text-gray-400"
                  />
                }
                allowClear
                className="min-w-72 max-w-72"
                onChange={(e) => {
                  // Pass a flag to indicate the field is now empty (after clear)
                  const isNowEmpty = (e?.target?.value ?? "").trim() === "";
                  onSearchChange?.(e, isNowEmpty);
                }}
                name={item}
                onPressEnter={onClickSearch}
              />
            </div>
          ))}
        </div>
        <button
          onClick={onClickSearch}
          className="px-4 py-1.5 bg-green-500 hover:bg-green-400 text-white rounded-lg flex items-center gap-2 h-fit my-auto"
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} />{" "}
          <FormattedMessage id="AGENTS.TABLE_TOOLBAR.SEARCH" />
        </button>
      </div>
      <div className="flex gap-2">
        <button
          className="px-4 py-1.5 bg-[#7239EA] hover:bg-[#7239EA]/80 text-white rounded-lg flex items-center gap-2 h-fit my-auto"
          onClick={onOpenCreateModal}
        >
          <FontAwesomeIcon icon={faPlus} />{" "}
          <FormattedMessage id="AGENTS.TABLE_TOOLBAR.CREATE" />
        </button>
        <button
          className="px-4 py-1.5 bg-green-500 hover:bg-green-400 text-white rounded-lg flex items-center gap-2 h-fit my-auto"
          onClick={onClickImport}
          type="button"
        >
          <FontAwesomeIcon icon={faFileCsv} />{" "}
          <FormattedMessage id="AGENTS.TABLE_TOOLBAR.IMPORT_CSV" />
        </button>
        <input
          ref={fileRef}
          type="file"
          accept=".csv"
          className="hidden"
          onChange={onFileChange}
        />
        <Tooltip
          title={
            <span>
              <FormattedMessage id="AGENTS.TABLE_TOOLBAR.DOWNLOAD_TEMPLATE" />{" "}
              <a
                href={tooltipLink}
                rel="noopener noreferrer"
                className="text-blue-500 underline-line"
              >
                <FormattedMessage id="AGENTS.TABLE_TOOLBAR.HERE" />
              </a>
            </span>
          }
          placement="topLeft"
          className="my-auto"
        >
          <KeenIcon
            icon="question"
            className="text-2xl text-gray-500 cursor-help"
          />
        </Tooltip>
      </div>
    </div>
  );
};

export default TableToolbar;
